module.exports = __webpack_public_path__ + "img/icon1.ebe4c466.png";